module.exports = __webpack_public_path__ + "img/beiersdorf.bf5efa9d.png";